module.exports = __webpack_public_path__ + "img/img3.7e28abca.png";